<template>
    <div>
        <nav2></nav2>
        <div>
            <el-row :gutter="10">
                <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple"></div></el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="grid-content bg-purple">
                        <el-table :data="list" style="width: 100%">
                            <el-table-column prop="FlowName" label="审批意见如下">
                            </el-table-column>
                        </el-table>
                    </div>
                    </el-col>
                <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple-light"></div></el-col>
            </el-row>
        </div>
        <theButton></theButton>
    </div>
</template>
<script>
// import theButton from './theButton'
// import nav2 from './nav2'
export default {
    data() {
        return {
            list: []
        };
    },
    components: {
        //   theButton,
        //   nav2
    }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/approvalOpinion2.vue